import FieldProject from "../../../generic/entity/project/project"
import FieldConfig from "../../../proto/field-config"
import ItemModelV2 from "../../../../model2/item2/item-model"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"

export default class FieldTimeReportProject extends FieldProject {

    constructor(config: FieldConfig) {
        super(config)

        this.isGroupByAvailable = true
    }

    groupItemValue(itemModel: ItemModelV2, _groupBy: GroupBy): any {
        return itemModel.timeReport?.projectId ?? null
    }

    groupLabel(value: any): string {
        // a meeting report may carry no project at all - the group is the "No parent" bucket
        if (!value) {
            return 'No project'
        }

        const project = gd.session.projects.get(value)
        if (!project) {
            return value
        }

        const parents = gd.session.projects.getAllParents(project.id).concat(project).map(p => p.name)
        return parents.join(' / ')
    }

    sortValue(value: any): string {
        const project = gd.session.projects.get(value)
        return project ? project.name.toLowerCase() : ''
    }
}
